import { ApplicationConfig, provideZoneChangeDetection, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { tokenInterceptor } from './_helper/token.interceptor';

import { ErrorHandler, isDevMode } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from "@sentry/angular";
import { provideTranslate } from './_i18n/translate.provider';
import { MarkdownModule } from 'ngx-markdown';
import { provideServiceWorker } from '@angular/service-worker';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import Lara from '@primeuix/themes/lara';

registerLocaleData(localeFr);
registerLocaleData(localeEn);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // provideClientHydration(), // deactivate SSR
    provideTranslate(),
    provideHttpClient(
      withInterceptors([tokenInterceptor]),
    ),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
    {
      provide: LOCALE_ID,
      useFactory: () => localStorage.getItem('lang') || 'en-US'
    },
    
    // Configuration PrimeNG v19
    provideAnimationsAsync(),
    providePrimeNG({
            theme: {
                preset: Lara
            }
        }), 

    ...((MarkdownModule.forRoot().providers) ?? []), 
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};